import { render, staticRenderFns } from "./BrandMediaContentBox.vue?vue&type=template&id=8072d172&"
import script from "./BrandMediaContentBox.vue?vue&type=script&lang=js&"
export * from "./BrandMediaContentBox.vue?vue&type=script&lang=js&"
import style0 from "./BrandMediaContentBox.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports